export default {
  path: '/reports/generated-reports',
  name: 'GeneratedReports',
  component: () => import(/* webpackChunkName: "base" */ '../views/GeneratedReportsView.vue')
}
